import React, { Component } from 'react';
import { connect } from "react-redux";
import { getComments } from "../../../Core/PhotographerComments/action";
import styles from '../../../Assets/Styles/Components/Book/Photograpers/comments.module.css';

class Comments extends Component {
    render() {
        return (
            <div className={`${styles.comments} ${Object.keys(this.props.comments.comments).length !== 0 && this.props.comments.comments.feed_backs.length !== 0 ? styles.show : ''}`} onClick={this.props.onClick}>
                <div className={styles.container} onClick={(e) => { e.stopPropagation(); }}>
                    <div className={styles.title}>
                        <div className={styles.titleName}> نظرات مشتریان درباره <b> {this.props.comments.comments.photographer_last_name} </b></div>
                        <div className={styles.closeBtn} onClick={this.props.onClick} />
                    </div>
                    <div className={styles.content}> {
                        this.props.comments && Object.keys(this.props.comments.comments).length !== 0 && this.props.comments.comments.feed_backs.map((cm) => (
                            <div className="container" key={`${cm.text} ${cm.user}`}>
                                <div className="row">
                                    <div className={`col-12  ${styles.commentCard}`}>
                                        <div className="col  p-0">
                                            <h4> {cm.user} </h4>
                                        </div>
                                        <br />
                                        <div className="row">
                                            <div className={`col-4 col-sm-3 p-0 justify-content-center align-items-center d-flex align-content-around flex-wrap ${styles.rate}`}>{(cm.quality + cm.service) / 2} از 10</div>
                                            <div className="col-8 col-sm-9 pr-0">
                                                {cm.text}
                                                <div className={`${styles.ex} row `}>
                                                    <div className="col"> <i className="fas fa-clock" />{cm.duration} ساعت </div>
                                                    <div className="col"><i className="fas fa-image" />{cm.photo_counts} عکس </div>
                                                    <div className="col"><i className="fas fa-camera" />{cm.start_time} </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    </div>
                    <div className={styles.bottomBar}>
                        <div className="container">
                            <div className="row">
                                <div className={`col-12 ${styles.btn}`} onClick={this.props.onClick}>بستن</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        comments: state.comments,
    };
};
export default connect(mapStateToProps, { getComments })(Comments);
